/*
 *
 * ClassesDetail constants
 *
 */

export const FLUSH_STATE = 'app/ClassesDetail/FLUSH_STATE';

export const LOAD_CLASS = 'app/ClassesDetail/LOAD_CLASS';
export const LOAD_CLASS_SUCCESS = 'app/ClassesDetail/LOAD_CLASS_SUCCESS';
export const LOAD_CLASS_ERROR = 'app/ClassesDetail/LOAD_CLASS_ERROR';